<template>
  <vs-popup
    class="sales-quote-pdf-popup"
    id="popup"
    title="Sales Quote"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow class="pdf-container">
      <div class="pdf-wrapper">
        <pdf ref="salesQuotePdfComponent" :src="file" class="pdf-viewer"></pdf>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-4">
        <vs-button
          @click="onClickDownload"
          button="submit"
          icon-pack="feather"
          icon="icon-download-cloud"
          color="primary"
          class="ml-auto mt-2"
        >
          Download
        </vs-button>
        <vs-button @click="onClickSendEmail" button="submit" icon-pack="feather" icon="icon-send" color="warning" class="ml-2 mt-2">Send</vs-button>

      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import pdf from "vue-pdf";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const CustomerRepository = RepositoryFactory.get("customer");
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

function initialState() {
  return {
    open: false,
    id: "",
    file: "",
    customer_id: '',
    quote_code: ''
  };
}

export default {
  name: "SalesQuotePrintView",
  data() {
    return initialState();
  },
  methods: {
    async onClickDownload() {
      window.open(this.file);
    },
    async openPopup(id, customer_id, quote_code) {
      try {
        await Object.assign(this.$data, initialState());
        this.id = id;
        this.customer_id = customer_id
        this.quote_code = quote_code
        await this.getRmOrderItemLabel();

        this.open = true;
      } catch (error) {}
    },
    async getRmOrderItemLabel() {
      this.$vs.loading();
      try {
        CustomerRepository.getSalesQuotePdf(this.id).then((response) => {
          const file = new Blob([response.data], { type: "application/pdf" });
          this.file = URL.createObjectURL(file);
          this.open = true;
          this.$vs.loading.close();
        });
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    onClickSendEmail(){
        this.$emit('sendEmail', this.id, this.customer_id, this.quote_code)
        this.open = false;
    }
  },
  components: {
    pdf,
  },
  mixins: [SuccessMessage, ErrorMessages],
};
</script>

<style scoped>
.pdf-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}

.pdf-wrapper {
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
